import type { JSX } from 'react';

import { WebhooksAvailablePanel } from 'features/webhooks';

import { useNotificationCenterContext } from './NotificationCenterLayout';

const NotificationCenterWebhooksPage = (): JSX.Element => {
  const { masterProject, subProjects } = useNotificationCenterContext();

  return <WebhooksAvailablePanel key={masterProject.id} projectId={masterProject.id} subProjects={subProjects} />;
};

export default NotificationCenterWebhooksPage;
